<template>
    <div id="TripSegms">
            <div  v-if="segmsOn">
                <l-polyline
                        v-for="item in segms"
                        :key="item.id"
                        :lat-lngs="item.latlngs"
                        :color="item.color"
                        @click="rmSegm(item)"
                >
                </l-polyline>
            </div>
            <l-circle-marker v-if="firstOn"
                    :lat-lng="circle.center"
                    :radius="circle.radius"
                    :color="circle.color"
            />
            <l-marker
                    v-for="item in markers"
                    :key="item.id"
                    :lat-lng="item.position"
                    :icon="item.icon"
                    @click="markIt(item)"
                    @contextmenu="setFirst($event, item)"
            >
            </l-marker>
            <l-marker v-if="placeOn"
                      :lat-lng="position"
                      :icon="pulseIcon"
                      @click="markIt(null)"
            />

        <b-container fluid class = "footer text-center">
            <center>
                <b-form-radio-group id="radio-group-2" v-model="selected" name="radio-sub-component">
                    <a v-b-popover.hover.top="this.$t('EDIT_SEGMS')" title="">
                        <b-form-radio value="TripSegms">
                            <font-awesome-icon icon="link" size="lg" :style="{ color: 'white' }" />
                        </b-form-radio>
                    </a>
                    <b-button @click.stop.prevent="saveSegms()">{{this.$t('SAVE')}}</b-button>
                    &nbsp;
                    <b-button @click.stop.prevent="cancel()">{{this.$t('CANCEL')}}</b-button>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <a v-b-popover.hover.top="this.$t('FST_PLACE')" title="" class="shBt">
                        <b-form-radio value="FirstPlace">
                            <font-awesome-icon icon="circle" size="lg" :style="{ color: 'white' }" />
                        </b-form-radio>
                    </a>
                    <a v-b-popover.hover.top="this.$t('HELP')" title="" class="shBt">
                        <b-button class="m-1" @click.stop.prevent="showHelp=true"><font-awesome-icon icon="question" size="lg" :style="{ color: 'white' }" /></b-button>
                    </a>
                </b-form-radio-group>

                <Help
                        v-on:closeHelp="showHelp=false"
                        v-bind:helpName="helpName"
                        v-if="showHelp"
                />

            </center>
        </b-container>
    </div>

</template>

<script>
import { BContainer, BButton, BFormRadio, BFormRadioGroup } from 'bootstrap-vue';
//import L from 'leaflet';
import { latLng, icon } from "leaflet";
import {LMarker, LPolyline, LCircleMarker } from "vue2-leaflet";
import { L } from "./LIconPulse.js";
import Help from "./Help.vue";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

export default {
  name: "TripSegms",
  components: {
    LMarker, LPolyline, LCircleMarker, Help,
    BContainer, BButton, BFormRadio, BFormRadioGroup
  },
  props: {
    map: Object
  },
  data: function() {
    return {
      zoom: this.$store.state.curZoom,
      center: latLng(55.75209, 37.61753),
      bounds: [],
      position: latLng(0, 0),
      showControl: true,
      userName: '',
      tripName: '',
      published: false,
      m: [],
      s: [],
      markers: [],
      segms: [],
      circle: {},
      placeOn: false,
      segmsOn: true,
      firstOn: true,
      first: -1,
      start: true,
      selected: 'TripSegms',
      idA: 0,
      idB: 0,
      icon: icon({
        iconUrl: '/data/markers/marker-color.png',
        iconSize: [25, 41],
        iconAnchor: [12, 37]
      }),
      pulseIcon: L.icon.pulse({iconSize:[20,20],color:'red'}),
      helpName: 'HelpTripSegms',
      showHelp: false
    };
  },
  mounted() {
    if(!this.$store.state.curUserName) this.$showErr(this.$t('TMOUT'), 401);
    this.userName = this.$rmEncHyp(this.$route.params.userName);
    this.tripName = this.$rmEncHyp(this.$route.params.itemName);
    //alert(this.userName+" "+this.tripName);
    this.getMyTripMarkers();
  },
  methods: {
    markIt(item) {
        //alert("oi");
        if(this.selected === 'TripSegms') {
            if(!item) {
                this.placeOn = false;
                this.start = true;
                return;
            }
            if(this.start) {
                this.placeOn = true;
                this.position = item.position;
                this.idA = item.id;
                this.start = false;
            } else {
                this.idB = item.id;
                if(this.segmExist()) {
                    this.start = true;
                    this.placeOn = false;
                    return;
                }
                this.start = true;
                this.placeOn = false;
                let segm = {
                    'placeAName': this.m[this.idA].markName,
                    'placeBName': this.m[this.idB].markName,
                    'placeALat': this.m[this.idA].markLat,
                    'placeALng': this.m[this.idA].markLng,
                    'placeBLat': this.m[this.idB].markLat,
                    'placeBLng': this.m[this.idB].markLng
                };
                this.s.push(segm);
                this.showTripSegms();
            }
        } else {
            if(item.id===this.first && this.firstOn) {
                this.firstOn = false;
                return;
            }
            this.firstOn = true;
            this.first = item.id;
            this.showFirst();
        }
    },
    rmSegm(item) {
        this.s.splice(item.rd,1);
        this.showTripSegms();
    },
    async getMyTripMarkers() {
        try {
            const response = await this.$http.get('/getMyTripMarkers', {
                params: {
                    tripName: this.tripName,
                    userName: this.userName,
                    aroundPlace: false
                }
            });
            this.m = response.data.marks;
            if(!this.m.length) {
                this.$showMsg(this.$t('EMPTY_LIST'));
                this.$router.go(-1);
            }
            this.s = response.data.segms;
            this.showTripMarkers();
            this.showTripSegms();
        }
        catch(error) {
            if(typeof error.response === 'undefined') this.$serveErr('TripSegms: getTripMarkers() '+error.message);
            else this.$showErr(error.response.data, error.response.status);
        }
    },
    showTripMarkers() {
        this.tripOnMark = true;
        this.tripOnFoot = true;
        this.placeOn = false;
        let minLat = 90.0; let minLng = 180.0; let maxLat = -90.0; let maxLng = -180.0;
        for(let i = 0; i < this.m.length; i++) {
            let item = {
                id: i,
                name: this.m[i].markName,
                position: latLng(this.m[i].markLat,this.m[i].markLng),

                icon: L.icon({
                    iconUrl : '/data/markers/'+this.m[i].markType+'.png',
                    iconSize : [35, 41],
                    iconAnchor : [12, 37]
                })

            };
            this.markers.push(item);
            if(this.m[i].markLat < minLat) minLat = this.m[i].markLat;
            if(this.m[i].markLng < minLng) minLng = this.m[i].markLng;
            if(this.m[i].markLat > maxLat) maxLat = this.m[i].markLat;
            if(this.m[i].markLng > maxLng) maxLng = this.m[i].markLng;
            if(this.m[i].isFirstPlaceOfTrip==='true') {
                this.first = i;
                this.showFirst();
            }
        }
        //this.bounds = [ latLng(minLat, minLng), latLng(maxLat, maxLng) ];
        this.map.fitBounds( [[minLat, minLng], [maxLat, maxLng]]);
       },
        showFirst() {


            this.circle.center = [ this.m[this.first].markLat, this.m[this.first].markLng ];
            //alert(this.circle.center.lat);
            this.circle.radius = 15;
            this.circle.color = 'red';
        },

        showTripSegms() {
            this.segms = [];
            for(let i = 0; i < this.s.length; i++) {
                let item = {
                    rd: i,
                    latlngs: [ [this.s[i].placeALat, this.s[i].placeALng], [this.s[i].placeBLat, this.s[i].placeBLng] ],
                    color: 'green'
                }
                this.segms.push(item);
            }
       },
        segmExist() {
            for(let i = 0; i < this.s.length; i++) {
                if( (this.s[i].placeAName===this.m[this.idA].markName && this.s[i].placeBName===this.m[this.idB].markName)
                    ||
                    (this.s[i].placeAName===this.m[this.idB].markName && this.s[i].placeBName===this.m[this.idA].markName) )
                    return  true;
            }
            return false;
        },
        async saveSegms() {
            let firstName = this.first == -1 ? '' : this.m[this.first].markName;
            //alert(firstName);
            let segmsJson = JSON.stringify(this.s);
            try {
                await this.$http.get('/editTripSegms', {
                    params: {
                        tripName: this.tripName,
                        fstPlaceName: firstName,
                        segmsJson: segmsJson
                    }
                });
                await this.$bvModal.msgBoxOk(this.$t('DONE'));
            } catch(error) {
                this.$showErr(error.response.data, error.response.status);
            } finally {
                this.$router.push({
                    path: '/Map/TripMarkers/'+this.$addEncHyp(this.tripName)+'/'+this.$addEncHyp(this.userName)
                }).catch(() => { alert("err "); })
            }
        },
        cancel() {
            this.$router.push({
                path: '/UserTripsList/'+this.$addEncHyp(this.userName),
                query: {
                    published: 'false'
                }
            }).catch(() => { alert("err "); })
        }
  }
};
</script>

<style >
</style>